<template>
  <div class="layout">
    <div class="layout__header">
      <div class="layout__title">
        <h3>Usuario</h3>
      </div>
    </div>
    <div class="card">
      <div class="card__title">
        <h5>Datos del usuario</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                id="codigo"
                v-model="form.codigo"
                placeholder="Escriba un código..."
              >
                Código*
                <span
                  v-if="errores.codigo"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.codigo[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                id="nombre"
                v-model="form.nombre"
                placeholder="Escriba un nombre..."
              >
                Nombre*
                <span
                  v-if="errores.nombre"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.nombre[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <!-- <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                id="email"
                v-model="form.email"
                placeholder="Escriba un e-mail..."
              >
                E-mail*
                <span
                  v-if="errores.email"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.email[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div> -->
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                :readonly="tipoEdicion === 'E'"
                id="nombre_usuario"
                v-model="form.nombre_usuario"
                placeholder="Escriba un nombre de usuario..."
              >
                Nombre de usuario*
                <span
                  v-if="errores.nombre_usuario"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.nombre_usuario[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                type="password"
                id="password"
                v-model="form.password"
                placeholder="Escriba una contraseña..."
              >
                Contraseña{{ tipoEdicion === "N" ? "*" : "" }}
                <span
                  v-if="errores.password"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.password[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                type="password"
                id="password_confirmation"
                v-model="form.password_confirmation"
                placeholder="Escriba una contraseña..."
              >
                Confirmación de contraseña{{ tipoEdicion === "N" ? "*" : "" }}
                <span
                  v-if="errores.password_confirmation"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.password_confirmation[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select">
              <div class="select-field">
                <select name="tipo" v-model="form.tipo" id="tipo">
                  <option value="N">Normal</option>
                  <option value="R">Recaudador</option>
                  <option value="S">Supervisor</option>
                  <option value="M">Supervisor/Recaudador</option>
                  <option value="V">Recaudador/Venta</option>
                  <option value="E">Supervisor/Cambio de Estado</option>
                </select>
                <label for="tipo">Tipo</label>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  id="bodega"
                  v-model="selectedBodega"
                  :options="bodegas"
                  placeholder="Seleccione..."
                  @input="inputBodega"
                  label="descripcion"
                ></v-select>
                <label for="bodega">Sucursal</label>
                <span
                  v-if="errores.bodega_id"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.bodega_id[0] }}</strong>
                </span>
              </div>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                id="rango_documento_ini"
                v-model="form.rango_documento_ini"
                placeholder="Escriba un número..."
              >
                Rango de documento inicial*
                <span
                  v-if="errores.rango_documento_ini"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.rango_documento_ini[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12 col-md-6">
            <div class="form-field">
              <input-field
                id="rango_documento_fin"
                v-model="form.rango_documento_fin"
                placeholder="Escriba un número..."
              >
                Rango de documento final*
                <span
                  v-if="errores.rango_documento_fin"
                  class="helper-text text-danger"
                  slot="helper"
                >
                  <strong>{{ errores.rango_documento_fin[0] }}</strong>
                </span>
              </input-field>
            </div>
          </div>
          <div class="col-xs-12">
            <label v-show="esSuperadmin" for="esAdministrador">
              <input
                type="checkbox"
                name="esAdministrador"
                id="esAdministrador"
                v-model="form.es_administrador"
              />
              <span>Es administrador</span>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12">
            <button type="button" @click="guardar" class="btn-primary">
              <i class="fa fa-save"></i>
              <span>Guardar usuario</span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="tipoEdicion === 'E'" class="card mt-2">
      <div class="card__title">
        <h5>Permisos del usuario</h5>
      </div>
      <div class="card__content">
        <div class="row">
          <div class="col-xs-12">
            <div class="form-field select2">
              <div class="select2-field">
                <v-select
                  @input="inputEmpresa"
                  v-model="selectedEmpresa"
                  :options="empresas"
                  label="descripcion"
                  id="empresa"
                  placeholder="Seleccione..."
                ></v-select>
                <label for="empresa">Empresa</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="tipoEdicion === 'E' && selectedEmpresa !== null"
      class="row mt-2"
    >
      <div class="col-xs-12">
        <div class="card">
          <div class="card__title">
            <h6>Roles</h6>
          </div>
          <div class="card__content">
            <checked-listbox
              name="roles[]"
              v-model="formPermisos.roles"
              :items="roles"
            ></checked-listbox>
          </div>
        </div>
      </div>
    </div>
    <div
      v-show="tipoEdicion === 'E' && selectedEmpresa !== null"
      class="row mt-2"
    >
      <div class="col-xs-12">
        <div class="card">
          <div class="card__content">
            <button @click="guardarPermisos" class="btn-primary">
              <i class="fa fa-save"></i>
              <span>Guardar permisos</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    vendedor: {
      type: Object,
      required: false,
      default: function () {
        return null;
      }
    },
    empresas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
    esSuperadmin: {
      type: Boolean,
      required: false,
      default: false,
    },
    usuarioId: {
      required: false,
      default: null,
    },
    bodegas: {
      type: Array,
      required: false,
      default: function () {
        return [];
      },
    },
  },
  data: function () {
    return {
      selectedEmpresa: null,
      formPermisos: {
        empresa_id: "",
        roles: [],
      },
      form: {
        nombre: "",
        nombre_usuario: "",
        password: "",
        password_confirmation: "",
        email: "",
        es_administrador: false,
        _method: undefined,
        tipo: "N",
        bodega_id: "",
        codigo: "",
        rango_documento_ini: "",
        rango_documento_fin: "",
      },
      tipoEdicion: "N",
      errores: {},
      roles: [],
      id: this.usuarioId,
      selectedBodega: null,
    };
  },
  methods: {
    inputBodega: function () {
      if (this.selectedBodega != null)
        this.form.bodega_id = this.selectedBodega.id;
      else this.form.bodega_id = "";
    },
    guardarPermisos: function () {
      let that = this;
      if (that.formPermisos.roles.length === 0)
        swal("Debe seleccionar al menos un rol.", "Aviso", "warning");
      else {
        axios
          .post(url + "/usuarios/" + that.id, that.formPermisos)
          .then(function () {
            swal(
              "Los permisos fueron almacenados exitósamente.",
              "Realizado",
              "success"
            );
          })
          .catch(function () {
            swal("Hubo un error, intente nuevamente.", "Error", "error");
          });
      }
    },
    guardar: function () {
      let that = this;
      this.form.email = this.form.nombre_usuario;
      let urlRequest = url + "/usuarios";
      if (this.tipoEdicion === "E") {
        this.form._method = "PUT";
        urlRequest += "/" + this.id;
      }
      axios
        .post(urlRequest, this.form)
        .then(function (response) {
          if (that.tipoEdicion === "N") {
            that.id = response.data.id;
            that.tipoEdicion = "E";
          }
          swal("El usuario fue almacenado.", "Realizado", "success");
        })
        .catch(function (error) {
          if (error && error.response) {
            let status = error.response.status;
            if (status === 422) {
              that.errores = error.response.data.errors;
              swal("El formulario tiene errores.", "Aviso", "warning");
              return;
            }
          }
          swal("Hubo un error, intente nuevamente.", "Error", "error");
        });
    },
    inputEmpresa: function () {
      if (this.selectedEmpresa !== null) {
        this.formPermisos.empresa_id = this.selectedEmpresa.id;
        let that = this;
        axios
          .get(
            url +
              "/usuarios/" +
              this.formPermisos.empresa_id +
              "/" +
              this.id +
              "/datos"
          )
          .then(function (response) {
            that.roles = response.data.roles;
            that.formPermisos.roles.splice(0, that.formPermisos.roles.length);
            for (let i = 0; i < response.data.roles_usuario.length; i++)
              that.formPermisos.roles.push(response.data.roles_usuario[i]);
          })
          .catch(function () {
            swal(
              "No se pudo cargar los datos de la empresa y el usuario.",
              "Error",
              "error"
            );
          });
      } else this.formPermisos.empresa_id = "";
    },
  },
  mounted: function () {
    if (this.usuarioId !== null && this.usuarioId !== "") {
      let that = this;
      axios
        .get(url + "/usuarios/" + this.usuarioId)
        .then(function (response) {
          that.form.nombre = response.data.nombre;
          that.form.nombre_usuario = response.data.nombre_usuario;
          that.form.es_administrador = response.data.es_superadmin === "A";
          that.form.email = response.data.email;
          that.form.tipo = response.data.tipo;
          that.form.codigo = response.data.codigo;
          that.form.rango_documento_fin = response.data.rango_documento_fin;
          that.form.rango_documento_ini = response.data.rango_documento_ini;
          that.tipoEdicion = "E";
          that.form.bodega_id = response.data.bodega_id;
          for (let i = 0; i < that.bodegas.length; i++) {
            if (that.bodegas[i].id == that.form.bodega_id) {
              that.selectedBodega = that.bodegas[i];
              break;
            }
          }
        })
        .catch(function () {
          swal(
            "Hubo un error al cargar el usuario seleccionado.",
            "Error",
            "error"
          );
        });
    }
    else if (this.vendedor != null) {
      this.form.nombre = this.vendedor.descripcion;
      this.form.codigo = this.vendedor.codigo;
      let nombres = this.vendedor.descripcion.replaceAll(' ', '.').split('.');
      this.form.nombre_usuario = nombres[0] + (nombres[1] != null?'.' + nombres[1]:'');
    }
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/usuarios/CrearEditarUsuario.vue